import { render, staticRenderFns } from "./EvidenceMedia.vue?vue&type=template&id=554c560c"
import script from "./EvidenceMedia.vue?vue&type=script&lang=ts"
export * from "./EvidenceMedia.vue?vue&type=script&lang=ts"
import style0 from "./EvidenceMedia.vue?vue&type=style&index=0&id=554c560c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports